import { render, staticRenderFns } from "./MobileLayout.vue?vue&type=template&id=2fc41c28&scoped=true"
import script from "./MobileLayout.vue?vue&type=script&lang=ts"
export * from "./MobileLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc41c28",
  null
  
)

export default component.exports